import angular from 'angular';

export default function AddSupportTicketNoteDialogController(
  ssDialogService,
  alerts,
  loaderService,
  supportSharedModelService
) {
  const vm = this;

  vm.handleCloseDialog = handleCloseDialog;
  vm.handleSaveDialog = handleSaveDialog;

  _activate();

  /** ***************************************
   * Event Handlers
   */

  function handleCloseDialog() {
    _closeDialog();
  }

  function handleSaveDialog(form) {
    if (form.$valid) {
      loaderService.showViewLoader = true;
      return _saveNote()
        .then((note) => {
          loaderService.showViewLoader = false;
          const items = [];
          items.push(note);

          angular.forEach(vm.ticketCopy.userFacingNotes, (userFacingNote) => {
            items.push(userFacingNote);
          });

          vm.ticketCopy.hasUserFacingNotes = true;
          vm.ticketCopy.userFacingNotes = items;

          angular.extend(vm.ticket, vm.ticketCopy);
          _closeDialog();
        })
        .catch((err) => {
          alerts.error(err);
        });
    }
  }

  /** ***************************************
   * Private Functions
   */

  function _activate() {
    vm.ticketCopy = angular.copy(vm.ticket);
  }

  function _saveNote() {
    const note = {
      ticketId: vm.ticketCopy.id,
      noteText: vm.noteText,
    };

    return supportSharedModelService.saveNote(note)
      .then((savedNote) => {
        alerts.success('Note saved successfully.');
        return savedNote;
      });
  }

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.support.addSupportTicketNoteDialog);
  }
}

AddSupportTicketNoteDialogController.$inject = [
  'ssDialogService',
  'alerts',
  'loaderService',
  'supportSharedModelService'
];
